// 路由缓存管理
//  引入状态机
import { createNamespacedHelpers } from "vuex";
const {
  mapMutations,
  mapState,
  mapGetters,
  mapActions
} = createNamespacedHelpers("tagsView");

const _isMobile = function () {
  let flag = window.navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  )
  return flag;
}

export default {
  data() {
    return {
      screenHeight: 0,
      screenWidth: 0,
      tableWidth: 0,
      tableHeight: 0,
      contentWidth: '99vw',
      contentHeight: '100vh',
      contentFullWidth: '99vw',
      heightDeviation: 230,
    }
  },
  mounted() {
    this.setScreen();
    let than = this;
    window.onresize = () => {
      return (() => {
        than.setScreen();
        window.screenHeight = window.innerHeight;
        this.screenHeight = window.screenHeight;
        this.screenWidth = window.screenWidth;

      })();
    };
    // console.log(this.$options.name)
    // this.$store.commit('setKeepAliveLists',this.$options.name)
    // this.setKeepAliveLists({
    //     optionName: this.$options.name,
    //     routeName: this.$route.name
    // });
  },

  methods: {
    ...mapActions({
      setKeepAliveLists: "setKeepAliveLists",
      deletAliveLists: "deletAliveLists"
    }),
    setScreen() {
      const ww = document.documentElement.clientWidth;
      if (!_isMobile()) {
        // 当前页面宽度相对于 1920宽的缩放比例，可根据自己需要修改。 
        const scale = 1366/ document.documentElement.clientWidth;
        let w = Math.round(scale * 100);
        if (w >= 100) this.contentWidth = '99.9vw';
        // else if (w<70) this.contentWidth='70vw';
        else this.contentWidth = w + 'vw';

        // 设置页面根节点字体大小（“Math.min(scale, 2)” 指最高放大比例为2）
      } else {
        this.contentWidth = '99.5vw';
      }
      this.contentHeight = window.innerHeight;// - this.heightDeviation+"px";
      this.tableHeight = window.innerHeight;// - this.heightDeviation;
      this.tableWidth = window.innerWidth - 120;
    }
  },
  watch: {
    screenHeight(val) {
      this.contentHeight = val;// - this.heightDeviation + "px";
      this.tableHeight = val;// - this.heightDeviation;
    },
    screenWidth(val) {
      this.tableWidth = val - 120;
    }
  }

  // deactivated: function () {
  //     console.log(this.$options.name + '我这个页面退出的会执行');
  //     console.log(this.$route.name);

  //     this.deletAliveLists({
  //         optionName: this.$options.name,
  //         routeName: this.$route.name
  //     })

  // },

}


// WEBPACK FOOTER //
// ./src/components/TagsView/mixin.js